import React, { useState, useEffect, useRef } from "react";
import "./receipt.css";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Button, TextField, TablePagination, Dialog, DialogTitle, DialogContent, DialogActions,
  Slide, Box, FormControl, Select, MenuItem, InputLabel, Grid, Typography, Container
} from "@mui/material";
import { Edit, Delete, Print, Save } from "@mui/icons-material";
// import Header from "../Header";
import api from "../../api/api";
import Swal from "sweetalert2";
import JsBarcode from "jsbarcode";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PaymentList = () => {
  const [payments, setPayments] = useState([]);
  const [students, setStudents] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [editData, setEditData] = useState(null);
  const [printOpen, setPrintOpen] = useState(false);
  const [receiptToPrint, setReceiptToPrint] = useState(null); 

  const token = localStorage.getItem("token");

  useEffect(() => {
    api
      .get("/api/users/students-reciept/", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setPayments(response.data);
        setFilteredPayments(response.data);
        setLoading(false);
      })
      .catch(() => {
        Swal.fire("Error", "Failed to fetch payments", "error");
        setLoading(false);
      });

    api
      .get("/api/users/students/", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setStudents(response.data);
      })
      .catch(() => {
        Swal.fire("Error", "Failed to fetch students", "error");
      });
  }, [token]);

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredPayments(
      payments.filter((p) =>
        p.student_full_name.toLowerCase().includes(value) ||
        p.receipt_number.toLowerCase().includes(value) ||
        p.semester.toLowerCase().includes(value)
      )
    );
  };

  const handleDelete = async (receiptNumber) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("access"); 
        api
          .delete(`/api/users/students-reciept/${receiptNumber}/`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(() => {
            setPayments(payments.filter((p) => p.id !== receiptNumber));
            setFilteredPayments(filteredPayments.filter((p) => p.id !== receiptNumber));
            Swal.fire("Deleted!", "Record has been deleted.", "success");
          })
          .catch(() => {
            Swal.fire("Error", "Failed to delete record", "error");
          });
      }
    });
  };

  const handleEdit = async (payment) => {
    setEditData(payment);
  };

  const handleEditSave = () => {
    const token = localStorage.getItem("access"); 
    api
      .put(`/api/users/students-reciept/${editData.receipt_number}/`, editData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        Swal.fire("Success", "Record updated successfully!", "success");
        setEditData(null);
        api.get("/api/users/students-reciept/", {
          headers: { Authorization: `Bearer ${token}` },
        }).then(response => {
          setPayments(response.data);
          setFilteredPayments(response.data);
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update record", "error");
      });
  };

  const handlePrintOpen = (payment) => {
    setReceiptToPrint(payment); 
    setPrintOpen(true);
    setTimeout(() => {
      JsBarcode(`#barcode_${payment.id}`, payment.receipt_number, { format: "CODE128" });
    }, 500);
  };

  const handlePrint = () => {
    window.print();
    setPrintOpen(false);  
  };

  return (
    <div>
      {/* <Header /> */}
      <Box sx={{ padding: "20px" }}>
        <h2>School Fee Payments</h2>
        <TextField label="Search by Student Name, Receipt Number or Semester" placeholder="" variant="outlined" fullWidth margin="normal" value={searchTerm} onChange={handleSearch} />

        {loading ? <p>Loading...</p> : null}

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {[ "Student Name", "Service", "Class", "Payer", "Semester", "Amount Due", "Amount Paid", "Balance", "Date", "Actions"].map((header) => (
                  <TableCell style={{ backgroundColor: "#0D1B2A", color: "#FFFFFF" }} key={header}><strong>{header}</strong></TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredPayments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((payment) => (
                <TableRow key={payment.id}>
                  <TableCell style={{ backgroundColor: "#0D1B2A", color: "#FFFFFF" }}>{payment.student_full_name}</TableCell>
                  <TableCell>{payment.services}</TableCell>
                  <TableCell>{payment.student_class}</TableCell>
                  <TableCell>{payment.payer_name}</TableCell>
                  <TableCell>{payment.semester}</TableCell>
                  <TableCell>${payment.amount_due}</TableCell>
                  <TableCell>${payment.amount_paid}</TableCell>
                  <TableCell>${payment.balance}</TableCell>
                  <TableCell>{payment.date}</TableCell>
                  <TableCell>
                    <Button color="primary" onClick={() => handleEdit(payment)}><Edit /></Button>
                    <Button color="secondary" onClick={() => handleDelete(payment.id)}><Delete /></Button>
                    <Button color="success" onClick={() => handlePrintOpen(payment)}><Print /></Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination component="div" count={filteredPayments.length} rowsPerPage={rowsPerPage} page={page}
          onPageChange={(e, newPage) => setPage(newPage)} onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))} />

        {/* Edit Dialog */}
        <Dialog open={editData !== null} TransitionComponent={Transition} maxWidth="md">
          <DialogTitle>Edit Payment</DialogTitle>
          <DialogContent>
            <FormControl fullWidth margin="normal">
              <InputLabel>Student</InputLabel>
              <Select
                value={editData?.student_id || ""}
                onChange={(e) => setEditData({ ...editData, student_id: e.target.value })}
                label="Student"
              >
                {students.map((student) => (
                  <MenuItem key={student.id} value={student.id}>{student.full_name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Amount Due"
              variant="outlined"
              fullWidth
              margin="normal"
              value={editData?.amount_due || ""}
              onChange={(e) => setEditData({ ...editData, amount_due: e.target.value })}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditData(null)} color="secondary">Cancel</Button>
            <Button onClick={handleEditSave} color="primary"><Save /> Save</Button>
          </DialogActions>
        </Dialog>

        {/* Print Dialog */}
        <Dialog open={printOpen} TransitionComponent={Transition} maxWidth="md">
          <DialogContent>
            <Paper sx={{ padding: 2, marginBottom: 2 }}>
              <DialogTitle style={{ textAlign: 'center' }}>
                <Container maxWidth="md" sx={{ textAlign: "center", my: 4 }}>
                  <Box sx={{ borderBottom: 2, borderColor: "primary.main", pb: 2 }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      JENA WILLIAMS EDUCATIONAL FOUNDATION
                    </Typography>
                    <Typography variant="h6" color="textSecondary">
                      Mount Barclay Community, Monrovia, Liberia
                    </Typography>
                    <Typography variant="body1" color="textSecondary" mt={1}>
                      Contacts: 85380736, 085370578, 93469
                    </Typography>
                  </Box>
                </Container>
              </DialogTitle>
              <h5 style={{ backgroundColor: "#03A9F4", color: "#0D1B2A", padding: "10px" }}>
                Student Payment Receipt Details:
              </h5>
              <p><strong>Name:</strong>{receiptToPrint?.student_full_name}</p>
              <p><strong>Class:</strong> {receiptToPrint?.student_class}</p>
              <p><strong>Receipt ID:</strong>{receiptToPrint?.receipt_number}</p>
              <p><strong>Pay Agent/Parents/Guidance:</strong> {receiptToPrint?.payer_name}</p>
            </Paper>
            {receiptToPrint && (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell><strong>Service</strong></TableCell>
                      <TableCell><strong>Total Amount</strong></TableCell>
                      <TableCell><strong>Amount Paid </strong></TableCell>
                      <TableCell><strong>Date</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{receiptToPrint.services}</TableCell>
                      <TableCell>{receiptToPrint.amount_due} ($)</TableCell>
                      <TableCell>${receiptToPrint.amount_paid} ($)</TableCell>
                      <TableCell>{receiptToPrint.date}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ backgroundColor: "#0D1B2A", color: "#FFFFFF" }}>
                        <strong color="error.main">Balance:{receiptToPrint.balance} ($)</strong>
                      </TableCell>
                      <TableCell><strong><p>{receiptToPrint.semester}</p></strong></TableCell>
                      <svg id={`barcode_${receiptToPrint.id}`} class="barcode"></svg>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handlePrint} variant="contained" color="primary">Print</Button>
            <Button onClick={() => setPrintOpen(false)} variant="outlined" color="secondary">Close</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
};

export default PaymentList;






// import React, { useState, useEffect, useRef } from "react";
// import "./receipt.css";
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
//   Button, TextField, TablePagination, Dialog, DialogTitle, DialogContent, DialogActions,
//   Slide, Box, FormControl, Select, MenuItem, InputLabel, Grid, Typography, Container
// } from "@mui/material";
// import { Edit, Delete, Print, Save } from "@mui/icons-material";
// // import Header from "../Header";
// import axios from "axios";
// import Swal from "sweetalert2";
// import JsBarcode from "jsbarcode";

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// const PaymentList = () => {
//   const [payments, setPayments] = useState([]);
//   const [students, setStudents] = useState([]);
//   const [filteredPayments, setFilteredPayments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [editData, setEditData] = useState(null);
//   const [printOpen, setPrintOpen] = useState(false);
//   const [receiptToPrint, setReceiptToPrint] = useState(null); 

//   const token = localStorage.getItem("token");

//   useEffect(() => {
//     axios
//       .get("http://127.0.0.1:8000/api/users/students-reciept/", {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         setPayments(response.data);
//         setFilteredPayments(response.data);
//         setLoading(false);
//       })
//       .catch(() => {
//         Swal.fire("Error", "Failed to fetch payments", "error");
//         setLoading(false);
//       });

//     axios
//       .get("http://127.0.0.1:8000/api/users/students/", {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         setStudents(response.data);
//       })
//       .catch(() => {
//         Swal.fire("Error", "Failed to fetch students", "error");
//       });
//   }, [token]);

//   const handleSearch = (event) => {
//     const value = event.target.value.toLowerCase();
//     setSearchTerm(value);
//     setFilteredPayments(
//       payments.filter((p) =>
//         p.student_full_name.toLowerCase().includes(value) ||
//         p.receipt_number.toLowerCase().includes(value) ||
//         p.semester.toLowerCase().includes(value)
//       )
//     );
//   };

// const handleDelete = async (receiptNumber) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "This action cannot be undone.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Delete",
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//     }).then((result) => {
//       if (result.isConfirmed) {
//          const token = localStorage.getItem("access"); 
//         axios
//           .delete(`http://127.0.0.1:8000/api/users/students-reciept/${receiptNumber}/`, {
//             headers: { Authorization: `Bearer ${token}` },
//           })
//           .then(() => {
//             setPayments(payments.filter((p) => p.id !== receiptNumber));
//             setFilteredPayments(filteredPayments.filter((p) => p.id !== receiptNumber));
//             Swal.fire("Deleted!", "Record has been deleted.", "success");
//           })
//           .catch(() => {
//             Swal.fire("Error", "Failed to delete record", "error");
//           });
//       }
//     });
//   };

// const handleEdit = async (payment) => {
//     setEditData(payment);
//   };

//   const handleEditSave = () => {
//     const token = localStorage.getItem("access"); // Ensure token is retrieved correctly
//     axios
     
//         .put(`http://127.0.0.1:8000/api/users/students-reciept/${editData.receipt_number}/`, editData, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then(() => {
//         Swal.fire("Success", "Record updated successfully!", "success");
//         setEditData(null);
//         axios.get("http://127.0.0.1:8000/api/users/students-reciept/", {
//           headers: { Authorization: `Bearer ${token}` },
//         }).then(response => {
//           setPayments(response.data);
//           setFilteredPayments(response.data);
//         });
//       })
//       .catch(() => {
//         Swal.fire("Error", "Failed to update record", "error");
//       });
//   };

//   const handlePrintOpen = (payment) => {
//     setReceiptToPrint(payment); // Set the specific payment to print
//     setPrintOpen(true);
//     // Generate barcode for the specific receipt
//     setTimeout(() => {
//       JsBarcode(`#barcode_${payment.id}`, payment.receipt_number, { format: "CODE128" });
//     }, 500);
//   };

//   const handlePrint = () => {
//     // Print only the selected receipt
//     window.print();
//     setPrintOpen(false);  // Close the dialog after printing
//   };

//   return (
//     <div>
//       {/* <Header /> */}
//       <Box sx={{ padding: "20px" }}>
//         <h2>School Fee Payments</h2>
//         <TextField label="Search by Student Name, Receipt Number or Semester" placeholder="" variant="outlined" fullWidth margin="normal" value={searchTerm} onChange={handleSearch} />

//         {loading ? <p>Loading...</p> : null}

//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 {[ "Student Name", "Service", "Class", "Payer", "Semester", "Amount Due", "Amount Paid", "Balance", "Date", "Actions"].map((header) => (
//                   <TableCell style={{ backgroundColor: "#0D1B2A", color: "#FFFFFF" }} key={header}><strong>{header}</strong></TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {filteredPayments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((payment) => (
//                 <TableRow key={payment.id}>
               
//                   <TableCell style={{ backgroundColor: "#0D1B2A", color: "#FFFFFF" }}>{payment.student_full_name}</TableCell>
//                   <TableCell>{payment.services}</TableCell>
//                   <TableCell>{payment.student_class}</TableCell>
//                   <TableCell>{payment.payer_name}</TableCell>
//                   <TableCell>{payment.semester}</TableCell>
//                   <TableCell>${payment.amount_due}</TableCell>
//                   <TableCell>${payment.amount_paid}</TableCell>
//                   <TableCell>${payment.balance}</TableCell>
//                   <TableCell>{payment.date}</TableCell>
//                   <TableCell>
//                     <Button color="primary" onClick={() => handleEdit(payment)}><Edit /></Button>
//                     <Button color="secondary" onClick={() => handleDelete(payment.id)}><Delete /></Button>
//                     <Button color="success" onClick={() => handlePrintOpen(payment)}><Print /></Button>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <TablePagination component="div" count={filteredPayments.length} rowsPerPage={rowsPerPage} page={page}
//           onPageChange={(e, newPage) => setPage(newPage)} onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))} />

//         {/* Edit Dialog */}
//         <Dialog open={editData !== null} TransitionComponent={Transition} maxWidth="md">
//           <DialogTitle>Edit Payment</DialogTitle>
//           <DialogContent>
//             <FormControl fullWidth margin="normal">
//               <InputLabel>Student</InputLabel>
//               <Select
//                 value={editData?.student_id || ""}
//                 onChange={(e) => setEditData({ ...editData, student_id: e.target.value })}
//                 label="Student"
//               >
//                 {students.map((student) => (
//                   <MenuItem key={student.id} value={student.id}>{student.full_name}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <TextField
//               label="Amount Due"
//               variant="outlined"
//               fullWidth
//               margin="normal"
//               value={editData?.amount_due || ""}
//               onChange={(e) => setEditData({ ...editData, amount_due: e.target.value })}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setEditData(null)} color="secondary">Cancel</Button>
//             <Button onClick={handleEditSave} color="primary"><Save /> Save</Button>
//           </DialogActions>
//         </Dialog>

//         {/* Print Dialog */}
//         <Dialog open={printOpen} TransitionComponent={Transition} maxWidth="md">
//       {/* <DialogTitle>Payment Receipt </DialogTitle> */}

//       <DialogContent>
    
//         <Paper sx={{ padding: 2, marginBottom: 2 }}>

//         <DialogTitle style={{ textAlign: 'center' }}>
//         <Container maxWidth="md" sx={{ textAlign: "center", my: 4 }}>
//       <Box sx={{ borderBottom: 2, borderColor: "primary.main", pb: 2 }}>
//         <Typography variant="h6" fontWeight="bold" gutterBottom>
//           JENA WILLIAMS EDUCATIONAL FOUNDATION
//         </Typography>
//         <Typography variant="h6" color="textSecondary">
//           Mount Barclay Community, Monrovia, Liberia
//         </Typography>
//         <Typography variant="body1" color="textSecondary" mt={1}>
//           Contacts: 85380736, 085370578, 93469
//         </Typography>
//         </Box>
//       </Container>
//        </DialogTitle>
          
//         <h5  style={{ backgroundColor: "#03A9F4", color: "#0D1B2A", padding: "10px" }}>
//           Student Payment Receipt Details:
//         </h5>
//           <p><strong>Name:</strong>{receiptToPrint?.student_full_name}</p>
//           <p><strong>Class:</strong> {receiptToPrint?.student_class}</p>
//           <p><strong>Receipt ID:</strong>{receiptToPrint?.receipt_number}</p>
//           <p><strong>Pay Agent/Parents/Guidance:</strong> {receiptToPrint?.payer_name}</p>
          
//         </Paper>
//       {receiptToPrint && (
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell><strong>Service</strong></TableCell>
//                 <TableCell><strong>Total Amount</strong></TableCell>
//                 <TableCell><strong>Amount Paid </strong></TableCell>
//                 <TableCell><strong>Date</strong></TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
             
//                 <TableRow >
//                   <TableCell>{receiptToPrint.services}</TableCell>
//                   <TableCell>{receiptToPrint.amount_due} ($)</TableCell>
//                   <TableCell>${receiptToPrint.amount_paid} ($)</TableCell>
//                   <TableCell>{receiptToPrint.date}</TableCell>
//                 </TableRow>
            
//               <TableRow>
//                 <TableCell style={{ backgroundColor: "#0D1B2A", color: "#FFFFFF" }}><strong color="error.main">Balance:{receiptToPrint.balance} ($)</strong></TableCell>
//                 <TableCell><strong><p>{receiptToPrint.semester}</p></strong></TableCell>
//                 <svg id={`barcode_${receiptToPrint.id}`} class="barcode"></svg>
//               </TableRow>
              
//             </TableBody>
//           </Table>
//         </TableContainer>
//         )}
     
//       </DialogContent>
      
//       <DialogActions>
//         <Button  onClick={handlePrint} variant="contained" color="primary">Print</Button>
//         <Button onClick={() => setPrintOpen(false)} variant="outlined" color="secondary">Close</Button>
//       </DialogActions>
//     </Dialog>
//       </Box>
//     </div>
//   );
// };

// export default PaymentList;

